import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import FileSelector from "@/lib/components/form/file/FileSelector.vue";


export default /*#__PURE__*/_defineComponent({
  name: 'AutoStoringFileSelector',
  props: {
  text: {
    type: String,
    required: true,
  },
  /**
   * The manager object
   */
  manager_class: {
    type: Object,
    required: true,
  },
  /**
   * The function inside the manager, that calls the store for updating
   */
  manager_mutator: {
    type: String,
    required: true,
  },
  icon: {
    type: String,
    required: true,
  },
  accept: {
    type: String,
    required: true,
  },
  is_multiple: Boolean,
  /*
   * if defined, will only store a video under the given instanceId. If not, will store a new file element.
   * If set, is_multiple is ignored and only one single video can be selected
   */
  linkToInstanceId: String,
  empty_store_before_load: {
    type: Boolean,
    default: true,
  }
},
  emits: ['onStored'],
  setup(__props, { emit }) {

const props = __props






const onChange = (files: File[]) =>
{
  if (props.empty_store_before_load)
    props.manager_class["reset"]();

  const instanceIds: string[] = [];

  files.forEach(file => {
    instanceIds.push(props.manager_class[props.manager_mutator](file, props.linkToInstanceId));
  });

  emit("onStored", instanceIds);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(FileSelector, {
    icon: __props.icon,
    text: __props.text,
    is_multiple: __props.is_multiple && !__props.linkToInstanceId,
    accept: __props.accept,
    onChange: onChange
  }, null, 8, ["icon", "text", "is_multiple", "accept"]))
}
}

})